import React from 'react'
import Navbar from '../components/Navbar'
import Terms from '../components/Terms'

const Terms_conditions = () => {
  return (
    <div>
      <Navbar />
      <Terms />
    </div>
  )
}

export default Terms_conditions